module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/bridge_image_02-bad0cf6a2993ff395ea4e9673c06e1f3.png";